export default __webpack_public_path__ + "static/pspo1-01-ee1079982a4b8d6e322406fec765e32c.png";